import { useEffect, useState } from 'react';

/**
 * หน่วงค่าไว้ก่อนส่งต่อ
 * ใช้กับช่องค้นหา ไม่ให้ยิง API ทุกตัวอักษรที่พิมพ์
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
